export default __webpack_public_path__ + "static/media/back_to_start.4c6ca26f.svg";